import React from "react";

type Props = {};

function Profile({}: Props) {
  return <>Profile</>;
}

export default Profile;
